import React from 'react';
import { Home, PermIdentity, ContactPage } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import '../styles/Navbar.css';


function Navbar() {

    // const [ expandNavbar, setExpandNavbar ] = useState(false);
    // const location = useLocation();

    // useEffect(() => {
    //     setExpandNavbar(true)
    // }, [location])


  return (
   <div className='top'>

<div className='links'>
            <Link to='/' className='href'> <Home /> </Link>
            <Link to='/portfolio' > <PermIdentity /> </Link>
            <Link to='/contact' > <ContactPage /> </Link>
        </div>
        {/* <div className='links'>
            <button className='button'><Link to='/' className='href'> Home </Link></button>
            <button className='button'><Link to='/portfolio' className='href'> Portfolio </Link></button>
            <button className='button'><Link to='/contact' className='href'> Contact </Link></button>
        </div> */}
  </div>
   
  )
}

export default Navbar;